export default __webpack_public_path__ + "static/media/1819 utensils top.ceaa1c7c.png";